// constants/testIds/dashboard.js — dashboard-related testids
export const DASH = {
  sidebar: 'dash-sidebar',
  navOverview: 'nav-overview',
  navStartups: 'nav-startups',
  navInvestors: 'nav-investors',
  navMeetings: 'nav-meetings',
  navChat: 'nav-chat',
  navAgreements: 'nav-agreements',
  navEntities: 'nav-entities',
  navEvents: 'nav-events',
  navUsers: 'nav-users',
  logoutBtn: 'logout-btn',
  overviewKpi: 'overview-kpi',
};

export const AUTH = {
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  signupName: 'signup-name',
  signupEmail: 'signup-email',
  signupPassword: 'signup-password',
  signupRole: 'signup-role',
  signupSubmit: 'signup-submit',
  googleBtn: 'google-signin',
};

export const PUB = {
  headerLogo: 'header-logo',
  ctaPricing: 'cta-pricing',
  ctaDemo: 'cta-demo',
  pricingRequestSubmit: 'pricing-submit',
};

export const STARTUP = {
  createBtn: 'create-startup',
  createSubmit: 'create-startup-submit',
  pitchSubmit: 'pitch-submit',
  qaStart: 'qa-start',
  qaSend: 'qa-send',
  psychoSubmit: 'psycho-submit',
};

export const AGREEMENT = {
  createBtn: 'create-agreement',
  signNDA: 'sign-nda',
  signMOU: 'sign-mou',
  partnerSelect: 'partner-select',
};

export const MEETING = {
  createBtn: 'create-meeting',
  approveBtn: 'meeting-approve',
};

export const CHAT = {
  newBtn: 'new-chat',
  input: 'chat-input',
  send: 'chat-send',
};
